module.exports = __webpack_public_path__ + "static/media/NICE_Step4a_Image1.3052c7dc.jpg";